export const fontConstants = {

    FETCH_ALLFONTS_REQUEST: 'FETCH_ALLFONTS_REQUEST',
    FETCH_ALLFONTS_SUCCESS: 'FETCH_ALLFONTS_SUCCESS',
    FETCH_ALLFONTS_FAILURE: 'FETCH_ALLFONTS_FAILURE',

    UPLOAD_FONT_REQUEST: 'UPLOAD_FONT_REQUEST',
    UPLOAD_FONT_SUCCESS: 'UPLOAD_FONT_SUCCESS',
    UPLOAD_FONT_FAILURE: 'UPLOAD_FONT_FAILURE',

    UPDATE_FONT_REQUEST: 'UPDATE_FONT_REQUEST',
    UPDATE_FONT_SUCCESS: 'UPDATE_FONT_SUCCESS',
    UPDATE_FONT_FAILURE: 'UPDATE_FONT_FAILURE',

    DELETE_FONT_REQUEST: 'DELETE_FONT_REQUEST',
    DELETE_FONT_SUCCESS: 'DELETE_FONT_SUCCESS',
    DELETE_FONT_FAILURE: 'DELETE_FONT_FAILURE',

}